module.exports = __webpack_public_path__ + "img/4有机产品项目建设.c31cca59.png";